<template>
  <div class="card executive-card mb-4">
    <div class="card-header section-header border-0 pt-3 pb-0 px-3">
      <h5 class="section-title">Analise por Estado (Ultimos 6 meses)</h5>
      <span class="section-badge">PR vs SC vs RS</span>
    </div>
    <div class="card-body pt-2">
      <p class="chart-help mb-2">
        Evolucao mensal de receitas por estado. O valor em destaque mostra o ultimo mes e a variacao no periodo.
      </p>
      <div class="state-resume">
        <div v-for="item in stateResume" :key="item.name" class="state-resume-card">
          <small>{{ item.name }}</small>
          <strong>{{ item.latest }}</strong>
          <span :class="item.growth >= 0 ? 'trend-up' : 'trend-down'">
            {{ item.growth >= 0 ? '↑' : '↓' }} {{ Math.abs(item.growth).toFixed(1) }}%
          </span>
        </div>
      </div>
      <apexchart type="line" height="300" :options="chartOptions" :series="series" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExecutiveStateComparisonSection',
  props: {
    categories: {
      type: Array,
      default: () => [],
    },
    series: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    stateResume() {
      return this.series.map((stateSeries) => {
        const first = Number(stateSeries.data[0] || 0)
        const latest = Number(stateSeries.data[stateSeries.data.length - 1] || 0)
        const growth = first ? ((latest - first) / first) * 100 : 0
        return {
          name: stateSeries.name,
          latest,
          growth,
        }
      })
    },
    chartOptions() {
      return {
        chart: {
          toolbar: { show: false },
        },
        stroke: {
          curve: 'smooth',
          width: 3,
        },
        markers: {
          size: 4,
          strokeWidth: 0,
        },
        dataLabels: { enabled: false },
        xaxis: {
          categories: this.categories,
          labels: {
            style: {
              colors: '#5c7285',
            },
          },
        },
        legend: {
          position: 'top',
          horizontalAlign: 'left',
          labels: {
            colors: '#3f5f76',
          },
        },
        yaxis: {
          labels: {
            formatter(value) {
              return `${Math.round(value)}`
            },
          },
        },
        tooltip: {
          y: {
            formatter(value) {
              return `${value} receitas`
            },
          },
        },
        colors: ['#188651', '#0f5f7f', '#1f3e63'],
        grid: {
          borderColor: '#e7eef3',
        },
      }
    },
  },
}
</script>

<style scoped>
.executive-card {
  border: 1px solid #d8e5ec;
  border-radius: 16px;
  box-shadow: 0 10px 24px rgba(9, 32, 58, 0.08);
}

.section-header {
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.section-title {
  font-size: 16px;
  font-weight: 700;
  color: #0f2b40;
}

.section-badge {
  border-radius: 999px;
  border: 1px solid #c8dae8;
  background: #f0f7fb;
  padding: 4px 10px;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-weight: 700;
  color: #2f5771;
}

.chart-help {
  font-size: 12px;
  color: #5b7284;
}

.state-resume {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 10px;
}

.state-resume-card {
  border: 1px solid #d8e5ec;
  background: #f8fcff;
  border-radius: 10px;
  padding: 7px 9px;
  display: flex;
  flex-direction: column;
}

.state-resume-card small {
  font-size: 11px;
  color: #577084;
  text-transform: uppercase;
  font-weight: 700;
}

.state-resume-card strong {
  font-size: 20px;
  color: #0f2b40;
  line-height: 1.1;
}

.trend-up {
  color: #0d7a3f;
  font-weight: 700;
  font-size: 12px;
}

.trend-down {
  color: #b43735;
  font-weight: 700;
  font-size: 12px;
}

@media (max-width: 767px) {
  .state-resume {
    grid-template-columns: 1fr;
  }
}
</style>
